<template>
  <!-- 数据概况 -->
  <div class="tag-flx">
    <Col v-for="(elx, idx) in data.list" :key="idx" :class="['tag-flx-bg', 'tag-flx-' + (elx.bg || 'purple')]" :span="data.colSpan">
      <div class="tag-flx-item">
        <img class="tag-icon" :src="elx.icon">
        <div class="tag-info">
          <p class="name">{{ elx.label }}</p>
          <p class="value">{{ elx.value | formatNumber }}</p>
        </div>
      </div>
    </Col>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        list: [],
        colSpan: 24
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-flx {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
  // margin-left: -8px;
  // margin-right: -8px;
  // justify-content: space-between;

    &-bg {
      background-size: contain !important;
      background-repeat: no-repeat !important;
      background-position: center center !important;
    }
    &-gree {
      background: url("../../assets/img/home/bg_green@2x.png");
    }
    &-purple {
      background: url("../../assets/img/home/bg_purple@2x.png");
    }
    &-orange {
      background: url("../../assets/img/home/bg_orange@2x.png");
    }
    &-purple {
      height: 110px;
      display: flex;
      align-items: center;
      padding-left: 8px;
      flex: 1;
      background: rgba(97, 73, 241, 0.08);
      border-radius: 4px;
      margin-right: 20px;
      &:last-child {
        margin-right: auto;
      }
    }
  .tag-flx-item {
    box-sizing: border-box;
    display: flex;
    // justify-content: start;
    align-items: center;
    .tag-icon {
      display: inline-block;
      width: 50px;
      height: 50px;
      margin-right: 14px;
      border-radius: 50%;
    }
    .tag-info {
      .name {
        font-size: 14px;
        font-weight: bold;
        color: #444444;
        margin-bottom: 5px;
      }
      .value {
        font-size: 26px;
        font-weight: 600;
        color: #000000;
      }
    }
  }
}
</style>
